<app-modal [table]="true" (modalClose)="closeModal()">
    <!-- Table 1 -->
    <div class="table extra-bottom">
        <h4 class="table__eyebrow">Table 2</h4>
        <h2 class="table__title">Candidate predictors included in model</h2>
        <!-- Dropdown 1 -->
        <div class="dropdown dropdown--table">
            <div class="dropdown__toggle" [ngClass]="{'dropdown__toggle--active' : dropdownList['dropdown1']}" (click)="toggleDropdown('1')">
            <p class="dropdown__toggle-text">Patient demographics and vital signs</p>
            <img *ngIf="!dropdownList['dropdown1']" src="assets/icons/icon-dropdown-arrow-black.svg" alt="Dropdown arrow">
            <img *ngIf="dropdownList['dropdown1']" src="assets/icons/icon-dropdown-arrow-white.svg" alt="Dropdown arrow">
        </div>
        </div>
        <div class="dropdown__list" *ngIf="dropdownList['dropdown1']" [ngClass]="{'no-bottom-border': dropdownList['dropdown1']}">
            <div class="table__list">
                <h3 class="table__subtitle">Variable</h3>
                <h3 class="table__subtitle">Description</h3>
            </div>
            <ul class="table__column">
                <li class="table__list-item">
                    <p class="variable"><span class="label">Variable:</span>Age (years)</p>
                    <p class="description"><span class="label">Description:</span>Value in years</p>
                </li>
                <li class="table__list-item">
                    <p class="variable"><span class="label">Variable:</span>Body mass index (kg/m<sup>2</sup>)</p>
                    <p class="description"><span class="label">Description:</span>Value of BMI</p>
                </li>
                <li class="table__list-item">
                    <p class="variable"><span class="label">Variable:</span>Weight (kg)</p>
                    <p class="description"><span class="label">Description:</span>For EPI patients the must have been in the absence of PERT</p>
                </li>
                <li class="table__list-item">
                    <p class="variable"><span class="label">Variable:</span>Age at diagnosis of chronic pancreatitis (years)</p>
                    <p class="description"><span class="label">Description:</span>Value in years</p>
                </li>
                <li class="table__list-item">
                    <p class="variable"><span class="label">Variable:</span>Race</p>
                    <p class="description"><span class="label">Description:</span>White, Black, Asian, other</p>
                </li>
                <li class="table__list-item">
                    <p class="variable"><span class="label">Variable:</span>Disability</p>
                    <p class="description"><span class="label">Description:</span>Yes or no</p>
                </li>
                <li class="table__list-item">
                    <p class="variable"><span class="label">Variable:</span>Sex</p>
                    <p class="description"><span class="label">Description:</span>Male, female</p>
                </li>
            </ul>
        </div>
        <!-- Dropdown 2 -->
        <div class="dropdown dropdown--table">
            <div class="dropdown__toggle" [ngClass]="{'dropdown__toggle--active' : dropdownList['dropdown2']}" (click)="toggleDropdown('2')">
            <p class="dropdown__toggle-text">Pancreas imaging findings (ideally within past 2 years)</p>
            <img *ngIf="!dropdownList['dropdown2']" src="assets/icons/icon-dropdown-arrow-black.svg" alt="Dropdown arrow">
            <img *ngIf="dropdownList['dropdown2']" src="assets/icons/icon-dropdown-arrow-white.svg" alt="Dropdown arrow">
        </div>
        </div>
        <div class="dropdown__list" *ngIf="dropdownList['dropdown2']">
            <div class="table__list">
                <h3 class="table__subtitle">Variable</h3>
                <h3 class="table__subtitle">Description</h3>
            </div>
            <ul class="table__column">
                <li class="table__list-item">
                    <p class="variable"><span class="label">Variable:</span>Pancreatic atrophy</p>
                    <p class="description"><span class="label">Description:</span>CT or MRI imaging finding</p>
                </li>
                <li class="table__list-item">
                    <p class="variable"><span class="label">Variable:</span>Pancreatic duct contour abnormality</p>
                    <p class="description"><span class="label">Description:</span>CT, MRI, MRCP, or EUS imaging finding</p>
                </li>
                <li class="table__list-item">
                    <p class="variable"><span class="label">Variable:</span>Pancreatic parenchymal calcification</p>
                    <p class="description"><span class="label">Description:</span>CT, MRI, MRCP, or EUS imaging finding</p>
                </li>
                <li class="table__list-item">
                    <p class="variable"><span class="label">Variable:</span>Pancreatic duct dilatation >7 mm</p>
                    <p class="description"><span class="label">Description:</span>CT, MRI, MRCP, or EUS imaging finding</p>
                </li>
                <li class="table__list-item">
                    <p class="variable"><span class="label">Variable:</span>Pancreatic duct calculus</p>
                    <p class="description"><span class="label">Description:</span>CT, MRI, MRCP, or EUS imaging finding</p>
                </li>
                <li class="table__list-item">
                    <p class="variable"><span class="label">Variable:</span>Pancreas divisum</p>
                    <p class="description"><span class="label">Description:</span>CT, MRI, MRCP, or EUS imaging finding</p>
                </li>
                <li class="table__list-item">
                    <p class="variable"><span class="label">Variable:</span>Pancreatic duct stricture</p>
                    <p class="description"><span class="label">Description:</span>CT, MRI, MRCP, or EUS imaging finding</p>
                </li>
            </ul>
        </div>
        <!-- Dropdown 3 -->
        <div class="dropdown dropdown--table">
            <div class="dropdown__toggle" [ngClass]="{'dropdown__toggle--active' : dropdownList['dropdown3']}" (click)="toggleDropdown('3')">
            <p class="dropdown__toggle-text">Abdominal and bowel symptoms</p>
            <img *ngIf="!dropdownList['dropdown3']" src="assets/icons/icon-dropdown-arrow-black.svg" alt="Dropdown arrow">
            <img *ngIf="dropdownList['dropdown3']" src="assets/icons/icon-dropdown-arrow-white.svg" alt="Dropdown arrow">
        </div>
        </div>
        <div class="dropdown__list" *ngIf="dropdownList['dropdown3']">
            <div class="table__list">
                <h3 class="table__subtitle">Variable <span class="subtitle-small">must be obtained in the absence of PERT</span></h3>
                <h3 class="table__subtitle">Description</h3>
            </div>
            <ul class="table__column">
                <li class="table__list-item">
                    <p class="variable"><span class="label">Variable:</span><span class="desktop-only">Steatorrhea</span><span class="mobile-only">Steatorrhea*</span></p>
                    <p class="description"><span class="label">Description:</span>Yes, or no; Clinical history of greasy, oily stools and/or fat droplets in toilet with stool</p>
                </li>
                <li class="table__list-item">
                    <p class="variable"><span class="label">Variable:</span><span class="desktop-only">Diarrhea</span><span class="mobile-only">Diarrhea*</span></p>
                    <p class="description"><span class="label">Description:</span>Yes or no</p>
                </li>
                <li class="table__list-item">
                    <p class="variable"><span class="label">Variable:</span><span class="desktop-only">Abdominal pain</span><span class="mobile-only">Abdominal pain*</span></p>
                    <p class="description"><span class="label">Description:</span>Yes or no</p>
                </li>
                <li class="table__list-item">
                    <p class="variable"><span class="label">Variable:</span><span class="desktop-only">Weight loss (lbs)</span><span class="mobile-only">Weight loss (lbs)*</span></p>
                    <p class="description"><span class="label">Description:</span>Yes, or no; Documented weight loss prior to index date of EPI or no-EPI status determination</p>
                </li>
                <li class="table__list-item">
                    <p class="variable"><span class="label">Variable:</span><span class="desktop-only">Flatulence</span><span class="mobile-only">Flatulence*</span></p>
                    <p class="description"><span class="label">Description:</span>Yes or no</p>
                </li>
                <li class="table__list-item">
                    <p class="variable"><span class="label">Variable:</span><span class="desktop-only">Lack of appetite</span><span class="mobile-only">Lack of appetite*</span></p>
                    <p class="description"><span class="label">Description:</span>Yes, or no</p>
                </li>
                <li class="table__list-item">
                    <p class="variable"><span class="label">Variable:</span><span class="desktop-only">Feeling of urgency to rush to the toilet (for a bowel movement)</span><span class="mobile-only">Feeling of urgency to rush to the toilet (for a bowel movement)*</span></p>
                    <p class="description"><span class="label">Description:</span>Yes or no</p>
                </li>
                <li class="table__list-item">
                    <p class="variable"><span class="label">Variable:</span><span class="desktop-only">Bloating</span><span class="mobile-only">Bloating*</span></p>
                    <p class="description"><span class="label">Description:</span>Yes, or no</p>
                </li>
                <li class="table__list-item">
                    <p class="variable"><span class="label">Variable:</span><span class="desktop-only">Nausea</span><span class="mobile-only">Nausea*</span></p>
                    <p class="description"><span class="label">Description:</span>Yes, or no</p>
                </li>
                <li class="table__list-item">
                    <p class="variable"><span class="label">Variable:</span><span class="desktop-only">Weight loss ratio (lbs/month)</span><span class="mobile-only">Weight loss ratio (lbs/month)*</span></p>
                    <p class="description"><span class="label">Description:</span>Yes, or no; Documented weight loss prior to index date of EPI or no-EPI status determination</p>
                </li>
            </ul>
        </div>
        <!-- Dropdown 4 -->
        <div class="dropdown dropdown--table">
            <div class="dropdown__toggle" [ngClass]="{'dropdown__toggle--active' : dropdownList['dropdown4']}" (click)="toggleDropdown('4')">
            <p class="dropdown__toggle-text">Patient habits</p>
            <img *ngIf="!dropdownList['dropdown4']" src="assets/icons/icon-dropdown-arrow-black.svg" alt="Dropdown arrow">
            <img *ngIf="dropdownList['dropdown4']" src="assets/icons/icon-dropdown-arrow-white.svg" alt="Dropdown arrow">
        </div>
        </div>
        <div class="dropdown__list" *ngIf="dropdownList['dropdown4']">
            <div class="table__list">
                <h3 class="table__subtitle">Variable</h3>
                <h3 class="table__subtitle">Description</h3>
            </div>
            <ul class="table__column">
                <li class="table__list-item">
                    <p class="variable"><span class="label">Variable:</span>Quantity of smoking</p>
                    <p class="description"><span class="label">Description:</span>Number of packs/year</p>
                </li>
                <li class="table__list-item">
                    <p class="variable"><span class="label">Variable:</span>Smoking (yes/no)</p>
                    <p class="description"><span class="label">Description:</span>Past, never or current</p>
                </li>
                <li class="table__list-item">
                    <p class="variable"><span class="label">Variable:</span>Alcohol use</p>
                    <p class="description"><span class="label">Description:</span>Past, never or current</p>
                </li>
                <li class="table__list-item">
                    <p class="variable"><span class="label">Variable:</span>Quantity of alcohol use</p>
                    <p class="description"><span class="label">Description:</span>Drinks per day</p>
                </li>
            </ul>
        </div>
        <!-- Dropdown 5 -->
        <div class="dropdown dropdown--table">
            <div class="dropdown__toggle" [ngClass]="{'dropdown__toggle--active' : dropdownList['dropdown5']}" (click)="toggleDropdown('5')">
            <p class="dropdown__toggle-text">Clinical laboratory</p>
            <img *ngIf="!dropdownList['dropdown5']" src="assets/icons/icon-dropdown-arrow-black.svg" alt="Dropdown arrow">
            <img *ngIf="dropdownList['dropdown5']" src="assets/icons/icon-dropdown-arrow-white.svg" alt="Dropdown arrow">
        </div>
        </div>
        <div class="dropdown__list" *ngIf="dropdownList['dropdown5']">
            <div class="table__list">
                <h3 class="table__subtitle">Variable</h3>
                <h3 class="table__subtitle">Description</h3>
            </div>
            <ul class="table__column">
                <li class="table__list-item">
                    <p class="variable"><span class="label">Variable:</span>Serum hemoglobin level (g/dL)</p>
                    <p class="description"><span class="label">Description:</span>For EPI patients this must have been obtained in the absence of PERT</p>
                </li>
                <li class="table__list-item">
                    <p class="variable"><span class="label">Variable:</span>Serum vitamin D level (ng/mL)</p>
                    <p class="description"><span class="label">Description:</span>For EPI patients this must have been obtained in the absence of PERT and in the absence of vitamin D supplementation</p>
                </li>
                <li class="table__list-item">
                    <p class="variable"><span class="label">Variable:</span>Serum albumin (g/dL)</p>
                    <p class="description"><span class="label">Description:</span>For EPI patients this must have been obtained in the absence of PERT</p>
                </li>
                <li class="table__list-item">
                    <p class="variable"><span class="label">Variable:</span>Serum hemoglobin A1c (%)</p>
                    <p class="description"><span class="label">Description:</span>Percentage value, for EPI patients this must have been obtained in the absence of PERT</p>
                </li>
                <li class="table__list-item">
                    <p class="variable"><span class="label">Variable:</span>Serum lipase (U/L)</p>
                    <p class="description"><span class="label">Description:</span>Must have been obtained in the quiescent phase of chronic pancreatitis and at least 3 months after a known acute pancreatitis episode</p>
                </li>
                <li class="table__list-item">
                    <p class="variable"><span class="label">Variable:</span>Serum magnesium (mg/dL)</p>
                    <p class="description"><span class="label">Description:</span>For EPI patients this must have been obtained in the absence of PERT and in the absence of oral magnesium supplementation</p>
                </li>
                <li class="table__list-item">
                    <p class="variable"><span class="label">Variable:</span>Serum pre-albumin (mg/dL)</p>
                    <p class="description"><span class="label">Description:</span>For EPI patients this must have been obtained in the absence of PERT</p>
                </li>
                <li class="table__list-item">
                    <p class="variable"><span class="label">Variable:</span>Serum retinol binding protein</p>
                    <p class="description"><span class="label">Description:</span>For EPI patients this must have been obtained in the absence of PERT</p>
                </li>
                <li class="table__list-item">
                    <p class="variable"><span class="label">Variable:</span>Serum vitamin A (µg/dL)</p>
                    <p class="description"><span class="label">Description:</span>For EPI patients this must have been obtained in the absence of PERT and in the absence of oral vitamin A supplementation</p>
                </li>
                <li class="table__list-item">
                    <p class="variable"><span class="label">Variable:</span>Serum vitamin E (µg/dL)</p>
                    <p class="description"><span class="label">Description:</span>For EPI patients this must have been obtained in the absence of PERT and in the absence of oral vitamin E supplementation</p>
                </li>
            </ul>
        </div>
        <!-- Dropdown 6 -->
        <div class="dropdown dropdown--table">
            <div class="dropdown__toggle" [ngClass]="{'dropdown__toggle--active' : dropdownList['dropdown6']}" (click)="toggleDropdown('6')">
            <p class="dropdown__toggle-text">Pancreatitis and gallstone history</p>
            <img *ngIf="!dropdownList['dropdown6']" src="assets/icons/icon-dropdown-arrow-black.svg" alt="Dropdown arrow">
            <img *ngIf="dropdownList['dropdown6']" src="assets/icons/icon-dropdown-arrow-white.svg" alt="Dropdown arrow">
        </div>
        </div>
        <div class="dropdown__list" *ngIf="dropdownList['dropdown6']">
            <div class="table__list">
                <h3 class="table__subtitle">Variable</h3>
                <h3 class="table__subtitle">Description</h3>
            </div>
            <ul class="table__column">
                <li class="table__list-item">
                    <p class="variable"><span class="label">Variable:</span>No. of known acute pancreatitis episodes</p>
                    <p class="description"><span class="label">Description:</span>Number value</p>
                </li>
                <li class="table__list-item">
                    <p class="variable"><span class="label">Variable:</span>History of recurrent acute pancreatitis</p>
                    <p class="description"><span class="label">Description:</span>Yes or no</p>
                </li>
                <li class="table__list-item">
                    <p class="variable"><span class="label">Variable:</span>History of gallstone(s)</p>
                    <p class="description"><span class="label">Description:</span>Past medical history</p>
                </li>
                <li class="table__list-item">
                    <p class="variable"><span class="label">Variable:</span>History of necrotizing pancreatitis</p>
                    <p class="description"><span class="label">Description:</span>Yes or no</p>
                </li>
            </ul>
        </div>
        <!-- Dropdown 7 -->
        <div class="dropdown dropdown--table">
            <div class="dropdown__toggle" [ngClass]="{'dropdown__toggle--active' : dropdownList['dropdown7']}" (click)="toggleDropdown('7')">
            <p class="dropdown__toggle-text">Concurrent medications</p>
            <img *ngIf="!dropdownList['dropdown7']" src="assets/icons/icon-dropdown-arrow-black.svg" alt="Dropdown arrow">
            <img *ngIf="dropdownList['dropdown7']" src="assets/icons/icon-dropdown-arrow-white.svg" alt="Dropdown arrow">
        </div>
        </div>
        <div class="dropdown__list" *ngIf="dropdownList['dropdown7']">
            <div class="table__list">
                <h3 class="table__subtitle">Variable</h3>
                <h3 class="table__subtitle">Description</h3>
            </div>
            <ul class="table__column">
                <li class="table__list-item">
                    <p class="variable"><span class="label">Variable:</span>Use of anti-motility agents</p>
                    <p class="description"><span class="label">Description:</span>Yes or no</p>
                </li>
                <li class="table__list-item">
                    <p class="variable"><span class="label">Variable:</span>Use of anxiety-relevant medications</p>
                    <p class="description"><span class="label">Description:</span>Use of citalopram, escitalopram, fluoxetine, fluvoxamine, chlordiazepoxide, paroxetine, sertraline, clomipramine, imipramine, isocarboxazid, phenelzine, selegiline, tranylcypromine</p>
                </li>
                <li class="table__list-item">
                    <p class="variable"><span class="label">Variable:</span>Use of sleep disturbance-relevant medications</p>
                    <p class="description"><span class="label">Description:</span>Use of alprazolam, klonopin, buspirone, diazepam, lorazepam, diphenhydramine, doxylamine succinate, zolpidem tartrate</p>
                </li>
                <li class="table__list-item">
                    <p class="variable"><span class="label">Variable:</span>Use of opiate analgesics</p>
                    <p class="description"><span class="label">Description:</span>Yes or no</p>
                </li>
            </ul>
        </div>
        <!-- Dropdown 8 -->
        <div class="dropdown dropdown--table">
            <div class="dropdown__toggle" [ngClass]="{'dropdown__toggle--active' : dropdownList['dropdown8']}" (click)="toggleDropdown('8')">
            <p class="dropdown__toggle-text">Family history</p>
            <img *ngIf="!dropdownList['dropdown8']" src="assets/icons/icon-dropdown-arrow-black.svg" alt="Dropdown arrow">
            <img *ngIf="dropdownList['dropdown8']" src="assets/icons/icon-dropdown-arrow-white.svg" alt="Dropdown arrow">
        </div>
        </div>
        <div class="dropdown__list" *ngIf="dropdownList['dropdown8']">
            <div class="table__list">
                <h3 class="table__subtitle">Variable</h3>
                <h3 class="table__subtitle">Description</h3>
            </div>
            <ul class="table__column">
                <li class="table__list-item">
                    <p class="variable"><span class="label">Variable:</span>Family history in first or second degree relative of (and/or): Cystic fibrosis, CP, pancreatic cancer, acute pancreatitis</p>
                    <p class="description"><span class="label">Description:</span>Yes or no</p>
                </li>
            </ul>
        </div>
        <!-- Dropdown 9 -->
        <div class="dropdown dropdown--table">
            <div class="dropdown__toggle" [ngClass]="{'dropdown__toggle--active' : dropdownList['dropdown9']}" (click)="toggleDropdown('9')">
            <p class="dropdown__toggle-text">Genetic risk factor</p>
            <img *ngIf="!dropdownList['dropdown9']" src="assets/icons/icon-dropdown-arrow-black.svg" alt="Dropdown arrow">
            <img *ngIf="dropdownList['dropdown9']" src="assets/icons/icon-dropdown-arrow-white.svg" alt="Dropdown arrow">
        </div>
        </div>
        <div class="dropdown__list" *ngIf="dropdownList['dropdown9']">
            <div class="table__list">
                <h3 class="table__subtitle">Variable</h3>
                <h3 class="table__subtitle">Description</h3>
            </div>
            <ul class="table__column">
                <li class="table__list-item">
                    <p class="variable"><span class="label">Variable:</span>Genetic defect in the cystic fibrosis transmembrane conductance regulator</p>
                    <p class="description"><span class="label">Description:</span>Genetic testing result</p>
                </li>
            </ul>
        </div>
        <!-- Dropdown 10 -->
        <div class="dropdown dropdown--table">
            <div class="dropdown__toggle" [ngClass]="{'dropdown__toggle--active' : dropdownList['dropdown10']}" (click)="toggleDropdown('10')">
            <p class="dropdown__toggle-text">Co-morbidities</p>
            <img *ngIf="!dropdownList['dropdown10']" src="assets/icons/icon-dropdown-arrow-black.svg" alt="Dropdown arrow">
            <img *ngIf="dropdownList['dropdown10']" src="assets/icons/icon-dropdown-arrow-white.svg" alt="Dropdown arrow">
        </div>
        </div>
        <div class="dropdown__list" *ngIf="dropdownList['dropdown10']">
            <div class="table__list">
                <h3 class="table__subtitle">Variable</h3>
                <h3 class="table__subtitle">Description</h3>
            </div>
            <ul class="table__column">
                <li class="table__list-item">
                    <p class="variable"><span class="label">Variable:</span>Diabetes</p>
                    <p class="description"><span class="label">Description:</span>Diagnosis</p>
                </li>
            </ul>
        </div>
        <!-- Disclaimer -->
        <div class="table__disclaimer">
            <p class="mobile-only pert-mobile">*must be obtained in the absence of PERT.</p>
            <p>BMI, body mass index; CP, chronic pancreatitis; CT, computed tomography; EPI, exocrine pancreatic insufficiency; EUS, endoscopic ultrasound; MRCP, magnetic resonance cholangiopancreatography; MRI, magnetic resonance imaging; PERT, pancreatic enzyme replacement therapy.</p>
        </div>
    </div>
</app-modal>